/* eslint-disable react/destructuring-assignment */
import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import {
  IHelicopterCompany,
  ITailNumber,
  IFlightPilot,
  ISettingsDataSchema,
  IAgency,
  IFireDispatch,
} from 'src/models/fire-fighting-dispatch.model';
import Moment from 'src/libraries/moment.library';
import services from 'src/services/fire-dispatch.service';

export const actionTypes = {
  FIRE_DISPATCH_GET_HELICOPTER_COMPANY_DATA:
    'FIRE_DISPATCH_GET_HELICOPTER_COMPANY_DATA',
  FIRE_DISPATCH_GET_PILOTS_DATA: 'FIRE_DISPATCH_GET_PILOTS_DATA',
  FIRE_DISPATCH_GET_FIRE_AGENCY_DATA: 'FIRE_DISPATCH_GET_FIRE_AGENCY_DATA',
  FIRE_DISPATCH_GET_DATA: 'FIRE_DISPATCH_GET_DATA',
  FIRE_DISPATCH_DEFAULT_DATA: 'FIRE_DISPATCH_DEFAULT_DATA',
  FIRE_DISPATCH_SAVED_DATA: 'FIRE_DISPATCH_SAVED_DATA',
  FIRE_DISPATCH_CREATE_DATA: 'FIRE_DISPATCH_CREATE_DATA',
} as const;

export const asyncActions = {
  getHelicopterCompanyData: {
    type: actionTypes.FIRE_DISPATCH_GET_HELICOPTER_COMPANY_DATA,
    service: services.getHelicopterCompanyData,
  },
  getFireAgencyData: {
    type: actionTypes.FIRE_DISPATCH_GET_FIRE_AGENCY_DATA,
    service: services.getFireAgencyData,
  },
  saveFireDispatchData: {
    type: actionTypes.FIRE_DISPATCH_SAVED_DATA,
    service: services.saveFireDispatchData,
  },
  createFireDispatchPOST: {
    type: actionTypes.FIRE_DISPATCH_CREATE_DATA,
    service: services.createFireDispatchPOST,
  },
  getFireDispatchDetailsData: {
    type: actionTypes.FIRE_DISPATCH_GET_DATA,
    service: services.getFireDispatchDetailsData,
  },
};
export type IFireFightDispatchAsync = typeof asyncActions;

export const syncActions = {
  getTailAndPilotsByHelicopterCompany: (data: number) => ({
    type: actionTypes.FIRE_DISPATCH_GET_PILOTS_DATA,
    payload: data,
  }),
  setDefaultData: () => ({
    type: actionTypes.FIRE_DISPATCH_DEFAULT_DATA,
  }),
};
export type IFireFightDispatchSync = typeof syncActions;

export interface IFireFightingDispatchState
  extends ICommonState<IFireFightDispatchAsync & IFireFightDispatchSync> {
  helicopterCompanyList: Array<IHelicopterCompany>;
  tailNumberList: Array<ITailNumber>;
  pilotList: Array<IFlightPilot>;
  settings: ISettingsDataSchema;
  fireAgency: Array<IAgency>;
  defaultValues: IFireDispatch;
}

export const defaultState: IFireFightingDispatchState = {
  status: {},
  helicopterCompanyList: [],
  tailNumberList: [],
  pilotList: [],
  settings: { fuelCycles: 0, landingCycles: 0 },
  fireAgency: [],
  defaultValues: {
    dispatchId: null,
    dispatchDate: null,
    dispatchTime: null,
    liftoffTime: null,
    responseTime: null,
    returnTime: null,
    flightHours: null,
    flightReason: null,
    location: null,
    lattitude: null,
    longitude: null,
    operatorID: 0,
    operatorName: null,
    tailNumber: null,
    pilot: null,
    coPilot: null,
    dipCount: null,
    dropCount: null,
    waterGallons: null,
    waterLiters: null,
    fuelCycles: 0,
    landingCycles: 0,
    fireName: null,
    fireComments: null,
    burnedAcres: null,
    billableLaunch: null,
    fireAgency: null,
    status: null,
    reason: null,
    enteredBy: null,
    updatedBy: null,
    flightNumber: null,
    dataSaved: false,
    DispatchDrops: [],
  },
};

const FireFightingDispatchReducer = (
  state: IFireFightingDispatchState = defaultState,
  action: IReducerAction<IFireFightDispatchAsync & IFireFightDispatchSync>
): IFireFightingDispatchState => {
  switch (action.type) {
    case actionTypes.FIRE_DISPATCH_GET_HELICOPTER_COMPANY_DATA: {
      return {
        ...state,
        helicopterCompanyList: action.payload?.operators.rows || [],
      };
    }
    case actionTypes.FIRE_DISPATCH_GET_PILOTS_DATA: {
      const operatorData = state.helicopterCompanyList.filter(
        (data: IHelicopterCompany) => {
          return data.operatorId === action.payload;
        }
      );
      return {
        ...state,
        pilotList: operatorData[0]?.Pilots || [],
        tailNumberList: operatorData[0]?.TailNumbers || [],
      };
    }
    case actionTypes.FIRE_DISPATCH_GET_FIRE_AGENCY_DATA: {
      return {
        ...state,
        fireAgency: action.payload?.fireAgencies?.rows || [],
      };
    }
    case actionTypes.FIRE_DISPATCH_GET_DATA: {
      const data =
        action.payload?.fireDispatch?.rows[0] || defaultState.defaultValues;
      return {
        ...state,
        defaultValues: {
          ...data,
          dispatchDate: Moment(data.dispatchDate).toDate(),
          dispatchTime: data.dispatchTime
            ? data.dispatchTime.replace(':', '')
            : null,
          liftoffTime: data.liftoffTime
            ? data.liftoffTime.replace(':', '')
            : null,
          returnTime: data.returnTime ? data.returnTime.replace(':', '') : null,
          status: data.status || null,
          dataSaved: false,
        },
      };
    }
    case actionTypes.FIRE_DISPATCH_SAVED_DATA: {
      const data = action.payload?.fireDispatch || defaultState.defaultValues;
      return {
        ...state,
        defaultValues: {
          ...data,
          dispatchDate: Moment(data.dispatchDate).toDate(),
          dispatchTime: data.dispatchTime
            ? data.dispatchTime.replace(':', '')
            : null,
          liftoffTime: data.liftoffTime
            ? data.liftoffTime.replace(':', '')
            : null,
          returnTime: data.returnTime ? data.returnTime.replace(':', '') : null,
          status: data.status || null,
          DispatchDrops: action.payload?.drops || [],
          dataSaved: true,
        },
      };
    }
    case actionTypes.FIRE_DISPATCH_DEFAULT_DATA: {
      return {
        ...state,
        defaultValues: defaultState.defaultValues,
      };
    }
    default: {
      return state;
    }
  }
};
export default FireFightingDispatchReducer;
